import { createSelector } from '@reduxjs/toolkit';

import { selectAttendedStatusId } from './dataSelectors';
import { selectCurrentParticipant } from './participantSelectors';

const selectCourseModulesByUsersAndDateEntries = (state) =>
    state.entities.courseService.courseModulesByUsersAndDate;

const selectParticipantsCourseEntries = (state) => state.entities.courseService.participantsCourses;

export const selectParticipantAttendedModules = createSelector(
    selectParticipantsCourseEntries,
    selectAttendedStatusId,
    selectCurrentParticipant,
    (participantsCourses, attendedId, currentParticipant) => {
        const participantsModules = participantsCourses.map((el) => el.modules).flat();
        return participantsModules.filter((el) =>
            el.participants.some(
                (entry) =>
                    entry.participantId === currentParticipant.id && entry.statusId === attendedId
            )
        );
    }
);

// This is for aggregated course modules - ie. for SchedulingAssistant
export const selectAllCourseModules = createSelector(
    selectCourseModulesByUsersAndDateEntries,
    (courseModulesByUsersAndDate) => Object.values(courseModulesByUsersAndDate).flat()
);
